import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

/**
 * Kamera ile barkod tarayıcı modal.
 * Props:
 *   - open: bool — modal görünür mü
 *   - onDetected(code: string) — barkod okunduğunda çağrılır
 *   - onClose() — modal kapatma
 */
export default function BarcodeScanner({ open, onDetected, onClose }) {
  const scannerRef = useRef(null);
  const containerId = 'barcode-scanner-region';
  const [error, setError] = useState('');
  const [running, setRunning] = useState(false);

  useEffect(() => {
    if (!open) return;
    let html5QrCode = null;
    let stopped = false;
    setError('');

    const start = async () => {
      try {
        html5QrCode = new Html5Qrcode(containerId, /* verbose */ false);
        scannerRef.current = html5QrCode;
        await html5QrCode.start(
          { facingMode: 'environment' }, // arka kamera
          {
            fps: 10,
            qrbox: { width: 260, height: 160 },
            aspectRatio: 1.5,
          },
          (decodedText) => {
            if (stopped) return;
            stopped = true;
            try { html5QrCode.stop().catch(() => {}); } catch {}
            onDetected && onDetected(decodedText);
          },
          () => { /* tarama hatası — yoksay */ }
        );
        setRunning(true);
      } catch (e) {
        setError('Kamera başlatılamadı: ' + (e?.message || e));
      }
    };
    start();

    return () => {
      stopped = true;
      const s = scannerRef.current;
      if (s) {
        try {
          s.stop().then(() => { try { s.clear(); } catch {} }).catch(() => {});
        } catch {}
      }
      setRunning(false);
    };
  }, [open, onDetected]);

  if (!open) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
      zIndex: 3000, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', padding: 16,
    }}>
      <div style={{
        background: 'var(--bg-card)', borderRadius: 12, padding: 14,
        maxWidth: 480, width: '100%', boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <strong style={{ fontSize: '0.95rem' }}>📷 Barkod Tara</strong>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.4rem', cursor: 'pointer', color: 'var(--text-secondary)', padding: 0, lineHeight: 1 }}>×</button>
        </div>

        <div id={containerId} style={{
          width: '100%', minHeight: 240,
          background: '#000', borderRadius: 8, overflow: 'hidden',
        }} />

        {error && (
          <div style={{ marginTop: 10, padding: 10, background: 'rgba(220,38,38,0.1)', color: 'var(--danger)', borderRadius: 6, fontSize: '0.82rem' }}>
            {error}
          </div>
        )}
        <div style={{ marginTop: 10, fontSize: '0.78rem', color: 'var(--text-tertiary)', textAlign: 'center' }}>
          {running ? 'Barkodu kameranın önüne tutun' : 'Kamera başlatılıyor...'}
        </div>
        <button
          onClick={onClose}
          style={{ marginTop: 12, width: '100%', padding: '10px', background: 'var(--bg-secondary)', border: '1px solid var(--border-secondary)', borderRadius: 8, cursor: 'pointer', color: 'var(--text-primary)', fontSize: '0.88rem' }}
        >İptal</button>
      </div>
    </div>
  );
}
